import { ceres_api } from "@/axios-config.js"

const Changelogs = {
    getChangelogs() {
        return ceres_api.get("/changelogs")
    }
}

export default Changelogs
